import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/style.scss";
import "./assets/css/rtlStyle.scss";
import "./assets/css/responsive.scss";
import "./languages/INEXT";
import { AuthProvider } from "./context/authContext";
import { UserProvider } from "./context/userContext";

const rootEl = document.getElementById("root");
const root = ReactDOM.createRoot(rootEl);
root.render(
  <Router>
    <AuthProvider>
      <UserProvider>
        <App />
      </UserProvider>
    </AuthProvider>
  </Router>
);
